import { mergeClassName as e } from "../../utils/data.js";
import { ButtonIcon as t } from "../Button/ButtonIcon.js";
import { Card as n } from "../Card/Card.js";
import { Close as r, Content as i, Dialog as a, DialogOverlay as o, DialogPortal as s, DialogTitle as c } from "../../node_modules/@radix-ui/react-dialog/dist/index.js";
import l from "./Modal.module.js";
import { Typography as u } from "../Typography/Typography.js";
import { Fragment as d, jsxDEV as f } from "react/jsx-dev-runtime";
import { XIcon as p } from "@phosphor-icons/react";
//#region lib/components/Modal/Modal.tsx
var m = "/opt/render/project/src/shared-ui/lib/components/Modal/Modal.tsx";
function h({ icon: h, title: g, children: _, footer: v, unwrappedContent: y, scrollable: b = !0, overlayProps: x, contentProps: S, cardProps: C, ...w }) {
	return /* @__PURE__ */ f(a, {
		...w,
		children: /* @__PURE__ */ f(s, { children: /* @__PURE__ */ f("div", {
			className: l.layer,
			children: [/* @__PURE__ */ f(o, {
				...x,
				className: e(l.overlay, x?.className)
			}, void 0, !1, {
				fileName: m,
				lineNumber: 45,
				columnNumber: 21
			}, this), /* @__PURE__ */ f(i, {
				...S,
				className: e(l.content, S?.className),
				children: y === void 0 ? /* @__PURE__ */ f(n, {
					color: "white",
					...C,
					className: e(l.card, C?.className),
					children: [
						/* @__PURE__ */ f("header", {
							className: l.header,
							children: [/* @__PURE__ */ f("div", {
								className: l.headerLeft,
								children: [h != null && /* @__PURE__ */ f("div", {
									className: l.headerIcon,
									children: h
								}, void 0, !1, {
									fileName: m,
									lineNumber: 61,
									columnNumber: 63
								}, this), g != null && /* @__PURE__ */ f(c, {
									asChild: !0,
									className: l.headerTitle,
									children: typeof g == "string" ? /* @__PURE__ */ f(u, {
										variant: "heading-medium",
										children: g
									}, void 0, !1, {
										fileName: m,
										lineNumber: 65,
										columnNumber: 53
									}, this) : g
								}, void 0, !1, {
									fileName: m,
									lineNumber: 63,
									columnNumber: 45
								}, this)]
							}, void 0, !0, {
								fileName: m,
								lineNumber: 60,
								columnNumber: 37
							}, this), /* @__PURE__ */ f("div", {
								className: l.closeButtonWrapper,
								children: /* @__PURE__ */ f(r, {
									asChild: !0,
									"aria-label": "Close",
									children: /* @__PURE__ */ f(t, {
										icon: /* @__PURE__ */ f(p, { size: 24 }, void 0, !1, {
											fileName: m,
											lineNumber: 74,
											columnNumber: 63
										}, this),
										color: "neutral",
										noBorder: !0
									}, void 0, !1, {
										fileName: m,
										lineNumber: 74,
										columnNumber: 45
									}, this)
								}, void 0, !1, {
									fileName: m,
									lineNumber: 73,
									columnNumber: 41
								}, this)
							}, void 0, !1, {
								fileName: m,
								lineNumber: 72,
								columnNumber: 37
							}, this)]
						}, void 0, !0, {
							fileName: m,
							lineNumber: 59,
							columnNumber: 33
						}, this),
						/* @__PURE__ */ f("div", {
							className: b ? l.scrollableBody : void 0,
							children: _
						}, void 0, !1, {
							fileName: m,
							lineNumber: 78,
							columnNumber: 33
						}, this),
						v && /* @__PURE__ */ f("footer", {
							className: l.footer,
							children: v
						}, void 0, !1, {
							fileName: m,
							lineNumber: 79,
							columnNumber: 44
						}, this)
					]
				}, void 0, !0, {
					fileName: m,
					lineNumber: 54,
					columnNumber: 29
				}, this) : /* @__PURE__ */ f(d, { children: [g != null && /* @__PURE__ */ f(c, {
					className: l.visuallyHidden,
					children: g
				}, void 0, !1, {
					fileName: m,
					lineNumber: 86,
					columnNumber: 37
				}, this), y] }, void 0, !0, {
					fileName: m,
					lineNumber: 82,
					columnNumber: 29
				}, this)
			}, void 0, !1, {
				fileName: m,
				lineNumber: 49,
				columnNumber: 21
			}, this)]
		}, void 0, !0, {
			fileName: m,
			lineNumber: 44,
			columnNumber: 17
		}, this) }, void 0, !1, {
			fileName: m,
			lineNumber: 40,
			columnNumber: 13
		}, this)
	}, void 0, !1, {
		fileName: m,
		lineNumber: 39,
		columnNumber: 9
	}, this);
}
//#endregion
export { h as Modal };
